import { InternationalizationHelper } from '../helpers/InternationalizationHelper';
import { Config } from './Config';
import { IFacebookEventListener } from './IFacebookEventListener';

declare var window: any;
declare var FB: any;

export class Facebook {

  private static instance: Facebook;
  private language:string = InternationalizationHelper.getLanguage();
  private listeners: IFacebookEventListener = null;
  private initDone: boolean = false;

  private constructor() {
    let self = this;

    //Load the SDK asynchronously
    (function(d, s, id) {
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) return;
      js = d.createElement(s); js.id = id;
      js.src = 'https://connect.facebook.net/' + self.language + '/sdk.js';
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

    window.fbAsyncInit = () => {

      FB.init({
          appId            : Config.fbAppId,
          autoLogAppEvents : true,
          xfbml            : true,
          version          : 'v11.0'
      });
      FB.AppEvents.logPageView();
      this.initDone = true;
    };
  }

  static getInstance(): Facebook {
    if(this.instance == null) {
      this.instance = new Facebook();
    }
    return this.instance;
  }

  addEventListener(listener: IFacebookEventListener) {
    this.listeners = listener;
  }

  removeEventListener(listener: IFacebookEventListener) {
    this.listeners = null;
  }

  login() {
    if(this.initDone == true) {
      let self = this;
      FB.login(function(response) {
        
        if (response.status === 'connected') {
          
          if(self.listeners){
            self.listeners.onFacebookConnected(response);
          }
        } else {
          // The person is not logged into this app or we are unable to tell. 
        }
      }, {scope: 'public_profile,email'});
    }
  }

  getFBRef() {
    return FB;
  }

}